import { render, staticRenderFns } from "./AlertContainer.vue?vue&type=template&id=34b64600&"
import script from "./AlertContainer.vue?vue&type=script&lang=js&"
export * from "./AlertContainer.vue?vue&type=script&lang=js&"
import style0 from "./AlertContainer.vue?vue&type=style&index=0&id=34b64600&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports